import * as React from 'react';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { PANTONES_PRINCIPALES } from '../tools/Pantones';
import { PropTypes } from 'prop-types';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';

// Parametros props
//steps: Numero de componentes que puede avanzar 
//componente: Componente React a mostrar

TextMobileStepper.propTypes = {
  name: PropTypes.string,
  steps: PropTypes.number.isRequired,
  componente: PropTypes.array.isRequired,
  labelsteps: PropTypes.array,
  initialStep: PropTypes.number,
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  beforeStepChange: PropTypes.func,
  onBlockedStepChange: PropTypes.func
};

TextMobileStepper.defaultProps = {
  name: 'Custom',
  steps: 4,
  componente: [{ Panel: <>{"Componente React 1"}</> }, { Panel: <>{"Componente React 2"}</> }, { Panel: <>{"Componente React 3"}</> }, { Panel: <>{"Componente React 4"}</> }],
  labelsteps: ["1", "2", "3", "4"],
  initialStep: 0,
  disabled: false,
  handleSubmit: () => { },
  beforeStepChange: () => true,
  onBlockedStepChange: () => { }
}

function TextMobileStepper(props) {
  const theme = useTheme();
  const normalizeStep = React.useCallback((step) => {
    const numericStep = Number(step);

    if (!Number.isFinite(numericStep)) {
      return 0;
    }

    return Math.min(Math.max(Math.floor(numericStep), 0), Math.max(props.steps - 1, 0));
  }, [props.steps]);
  const [activeStep, setActiveStep] = React.useState(() => normalizeStep(props.initialStep));
  const [isChangingStep, setIsChangingStep] = React.useState(false);
  const maxSteps = props.steps;

  React.useEffect(() => {
    setActiveStep(normalizeStep(props.initialStep));
  }, [normalizeStep, props.initialStep]);

  const resolveStepChange = async (targetStep) => {
    if (isChangingStep || targetStep < 0 || targetStep >= maxSteps || targetStep === activeStep) {
      return;
    }

    setIsChangingStep(true);

    try {
      const stepChangeResult = await Promise.resolve(
        props.beforeStepChange ? props.beforeStepChange(activeStep, targetStep) : true
      );

      if (stepChangeResult === false) {
        if (props.onBlockedStepChange) {
          props.onBlockedStepChange({
            allowed: false,
            reason: 'step_change_blocked'
          });
        }
        return;
      }

      if (stepChangeResult && typeof stepChangeResult === 'object' && stepChangeResult.allowed === false) {
        if (props.onBlockedStepChange) {
          props.onBlockedStepChange(stepChangeResult);
        }
        return;
      }

      setActiveStep(targetStep);
      if (props.handleSubmit) {
        props.handleSubmit({
          fromStep: activeStep,
          toStep: targetStep
        });
      }
    } catch (error) {
      if (props.onBlockedStepChange) {
        props.onBlockedStepChange({
          allowed: false,
          reason: 'step_change_error',
          severity: 'error',
          message: error?.message || 'No se pudo completar el cambio de paso.',
          error
        });
      }
    } finally {
      setIsChangingStep(false);
    }
  };

  const handleNext = () => {
    resolveStepChange(activeStep + 1);
  };

  const handleBack = () => {
    resolveStepChange(activeStep - 1);
  };

  const handleStep = (step) => () => {
    resolveStepChange(step);
  };

  return (<>
    {(props.steps > 0) ? (
      <Box sx={{ flexGrow: 1 }} name={props.name}>
        <Stepper nonLinear activeStep={activeStep} alternativeLabel>
          {props.labelsteps.map((label, index) => (
            <Step key={label}>
              {/* <StepLabel>{label}</StepLabel> */}
              <StepButton color="inherit" onClick={handleStep(index)} disabled={isChangingStep || props.disabled}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <Box sx={{ width: '100%', marginTop: 3, marginBottom: 3 }}>
          {props.componente[activeStep].Panel}
        </Box>
        <MobileStepper steps={maxSteps} position="static" activeStep={activeStep} style={{ fontWeight: 'bold', width: '50%', margin: '0 auto', textAlign: 'center', color: PANTONES_PRINCIPALES.GRIS }}
          nextButton={
            <Button size="small" style={{ textTransform: 'none' }} onClick={handleNext} disabled={activeStep === maxSteps - 1 || props.disabled || isChangingStep}>
              {/* {maxSteps === activeStep - 1 ? 'Completo' : 'Siguiente'} */}
              {isChangingStep ? 'Procesando...' : 'Siguiente'}
              {theme.direction === 'rtl' ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button size="small" style={{ textTransform: 'none' }} onClick={handleBack} disabled={activeStep === 0 || isChangingStep}>
              {theme.direction === 'rtl' ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Regresar
            </Button>
          }
        />
      </Box>
    ) : (<></>)}
  </>);
}

export default React.memo(TextMobileStepper);
